// used for real estate agent filter

export enum MoverRole {
    All = 'all',
    Transferee = 'transferee',
    Leaver = 'leaver',
}
